import React from "react";
import { color } from "../templates/ui";
import styled from "styled-components";
import Globe from "../atoms/icons/Globe";
import { getAppThemeName } from "../../../services/appTheme";
const StyledToggle = styled.button `
  position: relative;
  display: flex;
  align-items: center;
  border: none;
  background-color: transparent;
  height: 40px;
  font-family: Source Sans Pro, sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: ${color.base.base};
  cursor: pointer;
  transition: all 100ms ease-in-out;
  z-index: 3;

  &:focus {
    outline: none;
  }

  &:hover {
    color: ${props => props.theme.primary};

    .chevron-right {
      fill: ${props => props.theme.primary};
    }
  }
`;
const StyledGlobe = styled(Globe) `
  width: 26px;
  height: 26px;
  fill: ${props => props.theme.tertiary};
  
  @media only screen and (min-width: 768px) {
    fill: ${props => props.theme.tertiary};
    
    .auth & {
      fill: ${props => getAppThemeName() === 'inkassier' ? props.theme.languageToggle : props.theme.tertiary};
    }
  }
`;
const LanguageToggle = ({ onClick }) => (React.createElement(StyledToggle, { onClick: onClick },
    React.createElement(StyledGlobe, null)));
export default LanguageToggle;
